<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-4">
                <h4 class="card-title mb-4">Views Setting</h4>
                <vue-drag-tree
                  :data="treeModel"
                  :allowDrag="allowDrag"
                  :allowDrop="allowDrop"
                  :defaultText="'New Node'"
                  :displayCheckBox="displayCheckBox"
                  @current-node-clicked="curNodeClicked"
                  @drag="dragHandler"
                  @drag-enter="dragEnterHandler"
                  @drag-leave="dragLeaveHandler"
                  @drag-over="dragOverHandler"
                  @drag-end="dragEndHandler"
                  @drop="dropHandler"
                  @selectedCheckBox="selectedCheckBox"
                >
                </vue-drag-tree>
              </div>
              <div class="col-lg-8">
                <div class="row">
                  <div class="col-lg-9">
                    <h4 class="card-title mb-4">View:</h4>
                  </div>
                  <div class="col-lg-3">
                    <div class="text-sm-right">
                      <button
                        @click="toggleSideBar = !toggleSideBar"
                        type="button"
                        class="btn btn-success waves-effect waves-light"
                        v-if="viewIdSelected !== ''"
                      >
                        <i class="fa fa-plus"></i>
                        Add permission
                      </button>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        ></div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-right"
                        >
                          <label
                            class="d-inline-flex align-items-center"
                            style="min-width: 300px"
                          >
                            <b-form-input
                              v-model="filterPermission"
                              type="search"
                              placeholder="Search"
                              class="form-control form-control-sm ml-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-responsive">
                          <b-table
                            class="table table-centered table-nowrap"
                            ref="usertable"
                            :empty-text="'Not found any result'"
                            :show-empty="viewById.permissions.length == 0"
                            :bordered="true"
                            :filter="filterPermission"
                            :items="viewById.permissions"
                            align="center"
                            v-bind:fields="permissionTablefields"
                            :perPage="paginationPermission.pageSize"
                          >
                            <template v-slot:head(id)>
                              <div class="text-center">
                                Delete 
                                <b-form-checkbox
                                  v-show="isViewObjectPermissions"
                                  v-model="selectAll"
                                  @change="toggleSelectAll($event)"
                                  class="custom-checkbox-info"
                                >
                                </b-form-checkbox>
                              </div>
                            </template>
                            <template v-slot:cell(id)="data">
                              <div class="text-center">
                                <b-form-checkbox
                                  v-model="permissionSelected"
                                  :value="data.item"
                                                 :true-value="true"
                                  :false-value="false"
                                  @change="permissionSelectChange(data.item)"
                                  class="custom-checkbox-info mb-3"
                                  checked
                                ></b-form-checkbox>
                              </div>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 text-sm-right">
                        <div class="button-items">
                          <button
                            v-show="
                              permissionSelected && permissionSelected.length
                            "
                            type="button"
                            class="btn btn-primary"
                            @click="deleteViewPermission()"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <sideBar
        :toggleSideBar="toggleSideBar"
        :applicationCode="GET_APPLICATION_SELECTED.id"
        :viewId="viewIdSelected"
        @hidden="toggleSideBar = false"
        @getViewById="getViewById"
      ></sideBar>
    </div>
  </Layout>
</template>
<script>
import VueDragTree from "@/libs/vue-drag-tree/src/VueDragTree";
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import viewProvider from "@/helpers/service/view-provider";
import { applicationComputed } from "@/state/helpers";
import sideBar from "@/components/view-permission/sideBar";
export default {
  components: {
    Layout,
    PageHeader,
    "vue-drag-tree": VueDragTree,
    sideBar,
  },
  data() {
    return {
      title: "Views Permission",
      selectAll: false,

      items: [],
      treeModel: [],
      modal: {
        createView: false,
        deleteView: false,
        confirm: false,
      },
      paginationPermission: {
        totalRecords: 0,
        pageNo: 0,
        pageSize: 9999,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageOptions: [5, 10, 25, 50, 100],
      permissionTablefields: [
        {
          key: "display_name",
          label: "Display Name",
          sortable: true,
        },
        {
          key: "action",
          label: "Action Privilege",
          sortable: true,
        },
        {
          key: "method",
          label: "Method",
          sortable: true,
        },
        {
          key: "controller",
          label: "Category",
          sortable: true,
        },
        {
          key: "version",
          label: "Version",
          sortable: true,
        },
        {
          key: "id",
          label: "Delete",
          thStyle: "width:80px",
          sortable: false,
        },
      ],
      permissionSelected: [],
      filterPermission: "",
      displayCheckBox: false,
      isDuplicate: false,
      seletedViewId: "",
      parent_id: null,
      level: 0,
      isCreateFormRoot: false,
      toggleSideBar: false,
      viewIdSelected: "",
      viewById: {
        permissions: [],
      },
    };
  },
  async mounted() {
    await this.getTreeModel();
  },
  computed: {
    ...applicationComputed,
    isViewObjectPermissions() {
      return this.$validate.anyArrayObjectValid(this.viewById.permissions);
    },
  },
  methods: {
    permissionSelectChange(selectedItem) {
      if(this.viewById.permissions.length === this.permissionSelected.length){
        this.selectAll = true
      }else{
        this.selectAll = false
      }
      
    },
    toggleSelectAll(newVal) {
      if (newVal) {
        // Select all permissions
        this.permissionSelected = [...this.viewById.permissions];
      } else {
        // Deselect all
        this.permissionSelected = [];
      }
    },
    async getTreeModel() {
      let params = new URLSearchParams();
      params.append("no-cache", 1);
      let result = await viewProvider.getViewAsync(
        this.GET_APPLICATION_SELECTED.id,
        params
      );
      // console.log("result", result);
      if (result.status === 200) {
        if (result.data.length) this.treeModel = result.data;
      }
    },
    async getViewById(viewId, isNoCache) {
      let params = new URLSearchParams();
      if (isNoCache) params.append("no-cache", 1);
      let result = await viewProvider.getViewByIdAsync(
        this.GET_APPLICATION_SELECTED.id,
        viewId,
        params
      );
      //   console.log("result", result);
      if (result.status === 200) {
        this.viewById = result.data;
      }
    },
    async deleteViewPermission() {
      let deleted = this.permissionSelected.map((p) => p.id);
      let selected = this.viewById.permissions.filter(
        (q) => !deleted.includes(q.id)
      );
      let apiData = {
        permissions: selected,
      };
      let result = await viewProvider.deleteViewPermissionAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.viewIdSelected,
        apiData
      );
      if (result.status === 204) {
        this.getViewById(this.viewIdSelected, true);
        this.$utils.notification("success", "View is updated", 1500);
        this.permissionSelected = [];
        this.$emit("hidden");
      }
    },
    allowDrag(model, component) {
      // if (model.name === "Node 0-1") {
      //   // can't be dragged
      //   return false;
      // }
      // // can be dragged
      // return true;
      return false;
    },
    allowDrop(model, component) {
      // if (model.name === "Node 2-2") {
      //   // can't be placed
      //   return false;
      // }
      // // can be placed
      // return true;
      return false;
    },
    selectedCheckBox(event, model) {
      // console.log("event", event.target.checked);
      //  console.log("model", model);
    },
    async curNodeClicked(model, component) {
      // console.log("curNodeClicked", model, component);
      this.selectAll = false 
      this.viewIdSelected = model.view_id;
      this.permissionSelected = [];
      if (model.view_id !== null) {
        await this.getViewById(model.view_id, true);
      }
    },
    dragHandler(model, component, e) {
      // console.log('dragHandler: ', model, component, e);
    },
    dragEnterHandler(model, component, e) {
      // console.log('dragEnterHandler: ', model, component, e);
    },
    dragLeaveHandler(model, component, e) {
      // console.log('dragLeaveHandler: ', model, component, e);
    },
    dragOverHandler(model, component, e) {
      // console.log('dragOverHandler: ', model, component, e);
    },
    dragEndHandler(model, component, e) {
      // console.log('dragEndHandler: ', model, component, e);
    },
    dropHandler(model, component, e) {
      // console.log('dropHandler: ', model, component, e);
    },
  },
};
</script>
